import type { LocationEditProps } from "./location-edit.type";
import type { LocationFormValues } from "@/modules/location/location-form/";

import { useTranslation } from "react-i18next";

import {
  getDirectParentByType,
  getOrganizationAncestor,
} from "@/entities/ancestor";
import { useUpdateLocation } from "@/entities/location";
import LocationForm from "@/modules/location/location-form";

const LocationEdit = ({ location }: LocationEditProps) => {
  const { t } = useTranslation();

  const mutation = useUpdateLocation(location.id, {
    invalidateKeys: [["tree", "locations", location.id]],
  });
  const saveButtonLabel = t("global:update");
  const organization = getOrganizationAncestor(location.ancestors);

  // Get the direct parent location (excluding current entity to avoid self-reference)
  const parentLocation = getDirectParentByType(
    location.ancestors,
    "location",
    location.id
  );

  const initialValues: LocationFormValues = {
    name: location.name,
    description: location.description,
    coordinate: location.coordinate,
    geojson: location.geographical_data,
    organization: {
      label: organization?.name,
      value: organization?.id,
      key: organization?.id,
    },
    location: undefined,
  };

  if (parentLocation) {
    initialValues.location = {
      value: parentLocation.id,
      label: parentLocation.name,
      key: parentLocation.id,
    };
  }

  return (
    <LocationForm
      location={location}
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      // Use a key to force form re-initialization when parent location changes
      key={`${location.id}-${parentLocation?.id || "no-parent"}`}
    />
  );
};

export default LocationEdit;
